<template>
  <!-- 内容  -->
  <div v-loading='loading'>
    <el-card style="position:fixed;width:350px;z-index:1001"
             :body-style="{ padding: '10px'}"
             shadow="never">
      <div ref="elementTraverFilter">
        <!-- -------------筛选------------- -->
        <div v-if="showMapOrFilter">
          <!-- 筛选区 -->
          <div class="filter-area">
            <!-- 显示地图按钮 -->
            <el-button style="margin-right:5px"
                       icon="el-icon-map-location"
                       type="primary"
                       @click="closeShowMap"
                       size="mini"></el-button>
            <!-- 目的地 -->
            <select-dest placeholder="目的地"
                         :selectInputWidth="100"
                         @selectDest="selectDest"></select-dest>
            <!-- 搜索 -->
            <el-input size="mini"
                      style="width:100%;margin-left:5px"
                      placeholder="请输入迹点名称"
                      v-model="searchContentKeyword"
                      clearable>
              <el-button slot="append"
                         @click="searchButton"
                         icon="el-icon-search"></el-button>
            </el-input>

          </div>
          <div class="filter-area-tag">
            <!-- 标签 -->
            <!-- <select-tag :showTitle="true"
                        :creatNewTag="false"
                        titleName="主题"
                        :tagList="filterTags"
                        @getSelectList="getSelectList"></select-tag> -->
          </div>
        </div>
        <!-- -------------地图------------- -->
        <div style="position:relative"
             v-else>
          <show-all-traver-on-map ref='showLocationOnMap'
                                  :poiList="traver_point_list"></show-all-traver-on-map>
          <el-button style="position:absolute; top: 10px;left: 10px;z-index: 1001;"
                     @click="closeShowMap"
                     size="mini"
                     type="primary">关闭</el-button>
        </div>
      </div>
    </el-card>

    <!-- -------------迹点列表------------- -->
    <div :style="filterBlock"></div>
    <el-card shadow="never"
             :body-style="{ padding: '10px'}"
             style="width:350px">
      <!-- 列表 高度 -->
      <div :style="listHeight">
        <card-One-list :cardList="traver_point_list"
                       :checkedList="showSelectTraverList"
                       :showUpdate="false"
                       :showDest="false"
                       :showTag="false"
                       titleMiniName=""
                       @checkedItem="checkedItem"
                       @checkOneItemToDayTrip="checkOneItemToDayTrip"
                       @clickTraverPoint="showTraverPointOnMap"
                       @loadMorTraverPointer="loadMorTraverPointer"
                       buttonName=""></card-One-list>
      </div>
    </el-card>
  </div>
</template>

<script>
import SelectDest from '../select/SelectDest'
import SelectTag from '../select/SelectTag'
import CardOneList from '../cards/CardOneList'
import ShowAllTraverOnMap from '../../map/ShowAllTraverOnMap'
export default {
  name: 'select-traver-point',
  components: {
    'select-dest': SelectDest,
    'select-tag': SelectTag,
    'card-One-list': CardOneList,
    ShowAllTraverOnMap,
  },
  data() {
    return {
      showMapOrFilter: true,
      listHeight: `height:auto;`,
      filterBlock: ``,
      recommend_id: null,
      loading: false,
      searchContentKeyword: '',
      dest: '', // 选择的id
      filterTags: [],
      traver_point_list: this.traverPointList, //显示的迹点列表

      contentTags: [],
      tag_list: [],
      // 迹点列表
      showSelectTraverList: [], // 内容时使用需要绑定的迹点id
      page: 1,
    }
  },
  props: {
    // 当前所在城市的迹点列表
    traverPointList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },

  mounted() {
    // this.$refs.showLocationOnMap.lat = this.lat
    // this.$refs.showLocationOnMap.lng = this.lng
    // this.$refs.showLocationOnMap.pointerOnMap()
    this.getTraverPointList()
    this.getAllContentTag()
    this.filterBlock = `height:${this.getHeightBlock() + 35}px`
    // 获取目的地，再传入目的地
  },
  methods: {
    // ---------------------获取迹点列表---------------------
    getTraverPointList(page) {
      this.loading = true
      if (page == undefined) {
        page = 1
      }
      this.$http
        .get(
          `/traver/get_traver_point_list?source_map=2&traver_title=${this.searchContentKeyword}&dest=${this.dest}&p_size=20&p_num=${page}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            let list = res.data.data
            console.log('获取迹点数据', res)
            if (list.length == 0) {
              this.loading = false
              this.$message({
                message: '没有更多',
                type: 'error',
              })
              return
            }
            list.forEach((i) => {
              // console.log('i是什么：', i)
              if (i.poi_id !== null && i.poi_lat !== null) {
                let item = {
                  id: i.id,
                  title: i.traver_title,
                  title_mini: i.traver_info,
                  class_name: i.traver_class,
                  image: i.traver_cover,
                  lng: parseFloat(i.poi_lng),
                  lat: parseFloat(i.poi_lat),
                }
                this.traver_point_list.push(item)
                // console.log(this.traverPointList)
                this.loading = false
              }
            })
          } else {
            this.loading = false
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    loadMorTraverPointer() {
      // 加载更多点
      this.page += 1
      this.getTraverPointList(this.page)
    },
    getHeightBlock() {
      let height = this.$refs.elementTraverFilter.offsetHeight
      return height
    },
    // 是否显示地图
    closeShowMap() {
      this.showMapOrFilter = !this.showMapOrFilter
      this.$nextTick(() => {
        this.filterBlock = `height:${this.getHeightBlock() + 35}px`
      })
    },
    //  新建 推荐【作为绑定内容选择列表时使用】
    creatNewTraverContent() {
      // console.log(this.inputRecommsndTitle)
      // console.log(this.recommendTextArea)
      let newrecommend = {
        title: this.input_recommsnd_title,
        introduce: this.recommend_text_area,
        id_list: this.showSelectTraverList,
      }
      this.$emit('creatNewTraverContent', newrecommend)
    },
    // 【作为绑定内容选择列表时使用】选择内容
    checkedItem(val) {
      this.showSelectTraverList = val
      this.$emit('checkTraverPoint', val)
    },
    // 将迹点添加到日行程
    checkOneItemToDayTrip(val) {
      this.$emit('checkOneItemToDayTrip', val)
    },
    // 点击选择目的地
    selectDest(value) {
      this.dest = value
    },
    // 选择标签
    getSelectList(val) {},
    // 点击迹点图片，让其地图中显示
    showTraverPointOnMap(val) {
      if (this.$refs.showLocationOnMap) {
        // 替换 坐标图标
        this.$refs.showLocationOnMap.clickOnPointer(
          val.id,
          parseFloat(val.lat),
          parseFloat(val.lng)
        )
      }
    },
    // 点击搜索按钮
    searchButton() {
      this.traver_point_list = []
      this.getTraverPointList()
    },
    // 获取 内容 的所有标签【没必要，且不执行】
    getAllContentTag() {
      this.$http.get('/traver/get_content_tag').then((res) => {
        const { errno, errmsg, tag_list } = res.data
        if (errno == '0') {
          this.filterTags = tag_list
          // console.log(this.filterTags)
        } else {
          this.$message({
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
  },
}
</script>

<style>
/* .content-dialog .el-dialog__body {
  background-color: red;
} */

.filter-area {
  display: flex;
  margin-bottom: 10px;
  justify-content: flex-end;
}

.traver-add-recommend-title {
}
.traver-card-check-list {
  overflow: auto;
  padding: 5px;
  width: 96%;
  border: 1px solid rgb(204, 204, 204);
  background-color: rgb(240, 240, 240);
}
.content-card-check-map {
  width: 70%;
  padding-left: 10px;
}
</style>